import { Shield, Users, MapPin, Award, BookOpen, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEO from '@/components/SEO';

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <SEO
        title="About Us"
        description="Southern Bullion Exchange is Christchurch's trusted precious metals dealer. Family-owned since 2025, AML/CFT compliant, and authorised by Dillon Gage. Visit us in Bishopdale."
        path="/about"
      />
      <section className="bg-[#0A0A0A] py-16 text-center">
        <div className="max-w-7xl mx-auto px-6">
          <p className="section-label mb-3">About Us</p>
          <h1 className="text-4xl sm:text-5xl font-bold text-white" style={{ fontFamily: "Cinzel, serif" }}>Our Story</h1>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Real advice for real people. Christchurch's trusted precious metals dealer.
          </p>
        </div>
      </section>

      <section className="py-16 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <p className="section-label mb-3">Our Mission</p>
            <h2 className="text-3xl font-bold mb-6" style={{ fontFamily: "Cinzel, serif" }}>Building Wealth Through Precious Metals</h2>
            <div className="space-y-4 text-gray-600" style={{ fontFamily: "'Poppins', sans-serif" }}>
              <p>With industry experience and training since 2022, Southern Bullion Exchange was founded in 2025 from a simple belief: every New Zealander should have access to honest, straightforward advice about investing in precious metals.</p>
              <p>Based in Bishopdale, Christchurch, we're a locally owned and operated business that puts relationships first. We believe in face-to-face service, transparent pricing, and education that empowers our clients to make informed decisions.</p>
              <p>Our team brings together experience in finance, compliance, and precious metals trading, all focused on serving the everyday investor rather than institutional traders.</p>
            </div>
          </div>
          <div className="rounded-sm overflow-hidden shadow-[0_20px_40px_rgba(0,0,0,0.08)]">
            <img src="https://customer-assets.emergentagent.com/job_9291c06d-3d53-4aab-9c9b-bd4f24013ab1/artifacts/1f4h8q6x_shop-front-1.jpg" alt="Southern Bullion Exchange Store" className="w-full h-auto" loading="lazy" />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {[
            { icon: Shield, title: 'AML/CFT Compliant', desc: 'We adhere to Anti-Money Laundering and Countering Financing of Terrorism regulations, ensuring safe and compliant transactions.' },
            { icon: Users, title: 'Community Focused', desc: 'Proudly Christchurch-based, we serve our local community with personal service and accessible advice.' },
            { icon: Award, title: 'Industry Standards', desc: 'We operate in accordance with the Global Precious Metals Code and maintain high ethical standards in all dealings.' },
            { icon: BookOpen, title: 'Education First', desc: 'We believe informed investors are better investors. Our education hub provides free resources for all experience levels.' },
            { icon: MapPin, title: 'Physical Presence', desc: 'Visit our Bishopdale store for in-person consultations, valuations, and purchases. We believe in face-to-face service.' },
            { icon: Heart, title: 'Family Values', desc: 'Southern Bullion Exchange is built on family values of honesty, integrity, and genuine care for our clients\' financial wellbeing.' },
          ].map((item) => (
            <div key={item.title} className="p-6 border border-gray-200 rounded-sm">
              <div className="w-12 h-12 bg-[#0A0A0A] rounded-sm flex items-center justify-center mb-4">
                <item.icon size={24} className="text-[#D4AF37]" />
              </div>
              <h3 className="text-base font-semibold mb-2" style={{ fontFamily: "'Poppins', sans-serif" }}>{item.title}</h3>
              <p className="text-sm text-gray-500" style={{ fontFamily: "'Poppins', sans-serif" }}>{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-[#0A0A0A] p-12 rounded-sm text-center">
          <h2 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: "Cinzel, serif" }}>Ready to Start Investing?</h2>
          <p className="text-gray-400 mb-8 max-w-lg mx-auto" style={{ fontFamily: "'Poppins', sans-serif" }}>Whether you're a first-time buyer or experienced investor, we're here to help.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/products" className="btn-gold text-sm">Browse Products</Link>
            <Link to="/contact" className="btn-outline-gold text-sm">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
